export const apacCountryCodes = ['SG', 'HK'];

export enum UserAuthority {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  UPDATE_PROSPECT = 'UPDATE_PROSPECT',
  UPDATE_PARTNER = 'UPDATE_PARTNER',
  READ = 'READ',
  ADMIN_TASK_EXECUTE = 'ADMIN_TASK_EXECUTE',
  DELETE = 'DELETE',
  READ_ALL = 'READ_ALL',
  VIEW = 'VIEW',
  FTH_ACCESS = 'FTH_ACCESS',
  ASSIGNABLE_RM = 'ASSIGNABLE_RM',
  DELETE_CONTACT_NOTE = 'DELETE_CONTACT_NOTE',
  QUALIFIED_CLIENT_CONTACT = 'QUALIFIED_CLIENT_CONTACT',
}

export interface UserDTO {
  email: string;
  givenName: string;
  sureName: string;
  userLocation: string;
  username: string;
  roleList: string[];
  rm: boolean;
  rma: boolean;
  fth: boolean;
}

export interface UserAuthorityDTO {
  note: UserAuthority[];
}

export class User {
  email: string;

  givenName: string;

  sureName: string;

  userLocation: string;

  username: string;

  roleList: string[];

  hasNoteCreationAccess: boolean;

  hasNoteReadAccess: boolean;

  hasNoteEditAccess: boolean;

  hasNoteDeleteAccess: boolean;

  hasUpdateQualifiedContact: boolean;

  userAuthorities: { note: UserAuthority[] };

  isApac: boolean;

  constructor(
    email: string,
    givenName: string,
    sureName: string,
    userLocation: string,
    username: string,
    roleList: string[],
    userAuthorities: UserAuthorityDTO,
  ) {
    this.email = email;
    this.givenName = givenName;
    this.sureName = sureName;
    this.userLocation = userLocation;
    this.username = username;
    this.roleList = roleList;

    this.hasNoteCreationAccess = authorityListIncludeAtLeastOne([UserAuthority.CREATE], userAuthorities.note);
    this.hasNoteReadAccess = authorityListIncludeAtLeastOne(
      [UserAuthority.READ, UserAuthority.READ_ALL],
      userAuthorities.note,
    );
    this.hasNoteEditAccess = authorityListIncludeAtLeastOne([UserAuthority.UPDATE], userAuthorities.note);
    this.hasNoteDeleteAccess = authorityListIncludeAtLeastOne(
      [UserAuthority.DELETE_CONTACT_NOTE],
      userAuthorities.note,
    );
    this.hasUpdateQualifiedContact = authorityListIncludeAtLeastOne(
      [UserAuthority.QUALIFIED_CLIENT_CONTACT],
      userAuthorities.note,
    );
    this.userAuthorities = userAuthorities;
    this.isApac = false;
  }
}

const authorityListIncludeAtLeastOne = (expectedAuthorities: UserAuthority[], actualAuthorities: UserAuthority[]) => {
  return actualAuthorities.some((actualRole) => expectedAuthorities.includes(actualRole));
};
